import { Controller } from 'stimulus'
import { useBusItem } from '../mixins/useBusItem.js'
import { useDispatch, useDebounce } from 'stimulus-use'

export default class extends Controller {
  static targets = [
    'genericBulkButton', /* Stands for bulk buttons without special rules for enabling/disabling it.
                            (other than the amount of items selected) */
    'exportButton'
  ]

  static debounces = ['onSearchDataUpdated']

  static values = {
    busItemId: String,
    disableGenericBulkButtons: Boolean,
    disableExportButton: Boolean
  }

  // Members of EU Parliament => EU_MEP = 33
  // Global Legislators => INTERNATIONAL_LEGISLATOR = 36
  UNSUPPORTED_EXPORT_ENTITY_TYPES = ['eu_mep', 'international_legislator']

  // CALLBACKS
  connect() {
    useDebounce(this, { wait: 1000 })
    useBusItem(this)
    useDispatch(this)
  }

  disconnect() {
    this.removeFromBus()
  }

  disableGenericBulkButtonsValueChanged() {
    if (this.hasDisableGenericBulkButtonsValue) {
      this.genericBulkButtonTargets.forEach((button) => {
        this._toggleDisabledInButton(button, this.disableGenericBulkButtonsValue)
      })
    } else {
      this.disableGenericBulkButtonsValue = true
    }
  }

  disableExportButtonValueChanged() {
    if (this.hasDisableExportButtonValue) {
      this._toggleDisabledInButton(this.exportButtonTarget, this.disableExportButtonValue)
    } else {
      this.disableExportButtonValue = true
    }
  }

  // PUBLIC
  refreshButtons(event) {
    const areUnsupportedEntitiesSelected = () => {
      const entitySelector = this.getBusItem('cards-selector')
      const checkedList = entitySelector.checkboxesList.checkedList

      return Object.keys(checkedList).some((key) => {
        const checkedItemEntityType = checkedList[key].item.getAttribute('data-entity-type')
        return this.UNSUPPORTED_EXPORT_ENTITY_TYPES.includes(checkedItemEntityType)
      })
    }

    const cardsSelectedCount = this.getBusItem('cards-selector').checkboxesCheckedCountValue
    if (cardsSelectedCount <= 0) {
      this.disableGenericBulkButtonsValue = true
      this.disableExportButtonValue = true
    } else {
      this.disableGenericBulkButtonsValue = false
      this.disableExportButtonValue = areUnsupportedEntitiesSelected()
    }
  }

  // PRIVATE
  _toggleDisabledInButton(button, disabled) {
    if (disabled) {
      button.setAttribute('disabled', 'true')
    } else {
      button.removeAttribute('disabled')
    }
  }
}
